import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
} from '@mui/material';
import { DialogBackground, DialogTitleStyle } from '../assets/theme/Theme';
import { CloseIcon } from '../assets/icons/Icons';

interface LimitationPopup {
	open: boolean;
	onClose: () => void;
}

function LimitationPopup({ open, onClose }: LimitationPopup) {
	const handleEmailClick = () => {
		window.location.href = 'mailto:gobiga@senzmate.com';
	};

	const handleContactClick = () => {
		window.open('https://www.senzmate.com/company/contact/', '_blank');
	};

	return (
		<Dialog
			open={open}
			maxWidth="sm"
			fullWidth={true}
			style={DialogBackground}>
			<DialogTitle style={DialogTitleStyle}>
				Sandbox Limit Reached
				<IconButton onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<DialogContentText
					variant="subtitle2"
					style={{
						color: 'rgba(113, 113, 113, 1)',
						fontWeight: 600,
					}}>
					You have reached one or more Sandbox limits. Upgrade your
					plan or reach out to our team for assistance.
				</DialogContentText>
			</DialogContent>
			<DialogActions
				style={{ marginRight: '20px', marginBottom: '20px' }}>
				<Button
					sx={{
						paddingLeft: '15px',
						paddingRight: '5px',
						color: '#28696D',
						textTransform: 'none',
						marginRight: '0px',
					}}
					onClick={handleContactClick}>
					Contact Us
				</Button>
				<Button
					variant="contained"
					style={{
						backgroundColor: '#28696D',
						boxShadow: 'none',
						marginLeft: '10px',
						textTransform: 'none',
					}}
					onClick={handleEmailClick}>
					Email us
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default LimitationPopup;
